<!--  -->
<template>
  <div>
    <div class="tinymce_box">
      <div>
        <div class="tabselecr_box">
          <div class="search_box">
            <el-input v-model.trim="query.keywords" clearable style="width:300px;" placeholder="小程序名称/APPID" />
            <!-- <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:10px">
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select> -->
            <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
            <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" @click="addClick">新增</el-button>
          </div>
        </div>

        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
        >
          <el-table-column
            prop="name"
            label="小程序名称"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="APPID"
            align="center"
            width="260"
          />
          <el-table-column
            prop="gh_id"
            label="ghid"
            align="center"
            width="260"
          />
          <el-table-column
            prop="status_text"
            label="状态"
            align="center"
          />
          <el-table-column
            prop="created_time_text"
            label="创建时间"
            align="center"
          />
          <!-- <el-table-column
            align="center"
            prop="realName"
            width="180"
            label="创建人"
          /> -->
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="editClisk(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="deleteClick(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :current-page="query.page"
          :total="total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>

      <!-- 新增标签组弹窗 -->
      <el-dialog
        title="新增"
        :destroy-on-close="true"
        :visible.sync="addVisible"
        :modal-append-to-body="false"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="25%"
      >
        <addlibrary @addprogram="addprogram" />
      </el-dialog>
      <!-- 修改 -->
      <el-dialog
        title="修改"
        :destroy-on-close="true"
        :visible.sync="dialogVisible"
        :modal-append-to-body="false"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="25%"
      >
        <editlibrary ref="editview" @editprogram="editprogram" />
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { programList, deleteProgram } from '@/api/templatelist.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addlibrary from './addlibrary.vue'
import editlibrary from './editlibrary.vue'
export default {
  components: { PaginationRight, addlibrary, editlibrary },
  data() {
    return {
      formData: {
        name: '',
        appid: ''
      },
      query: {
        page: 1,
        page_size: 10,
        keywords: null
        // onlyMe: 2
      },
      tableData: [],
      total: null,
      addVisible: false, // 新增
      dialogVisible: false, // 修改
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }],
      id: null
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await programList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', this.tableData)
    },
    // 重置
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      // this.query.onlyMe = 2
      this.list()
    },
    // 搜索
    searchclick() {
      this.query.page = 1
      this.list()
    },
    addClick() {
      this.addVisible = true
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    addprogram() {
      this.addVisible = false
      this.list()
    },
    editprogram() {
      this.dialogVisible = false
      this.list()
    },
    // 编辑
    editClisk(row) {
      // console.log('edit', row)
      // this.id = row.id
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editview.send(row)
      })
    },
    // 删除
    deleteClick(row) {
      console.log('delete', row)
      this.id = row.id

      this.$confirm('确定要删除此条小程序?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const delData = await deleteProgram({ id: this.id })
        if (delData.code === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymce_box{
  padding-right: 30px;
}
.tinymceserve_box{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox{
  width: 200px;
  margin-left: 20px;
}
.functional_area{
  margin-top: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.choose_plate{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.template_addbutton{
  text-align: right;
  width: 80%;
}
.sewrw_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box{
  display: flex;
  align-items: center;
}
.content_box{
  /* width: 130px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
</style>

